var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (errors && errors.length > 0) { 
__p+='\n  ';
 errors.forEach(function(errorMessage) { 
__p+='\n    <div class="alert alert-danger">\n      '+
((__t=( errorMessage ))==null?'':__t)+
'\n    </div>\n  ';
 }) 
__p+='\n';
 } 
__p+='\n\n<form role="form" class="virtual-line-form form-horizontal">\n  <div class="alert alert-warning ui-hidden" data-action="adwords-media-type-warning">\n    Warning: if you change the media type, calls to this number will no longer get AdWords attribution.\n  </div>\n\n  <div class="sb-field-group" id="promo_number_field" style="'+
((__t=( config.displayIfExists(config.promo_number) ))==null?'':__t)+
'">\n    <label class="sb-field-label">Promo Number</label>\n    <div id="promo_number_fixed" style="'+
((__t=( config.displayIfExists(config.promo_number) ))==null?'':__t)+
'">'+
((__t=( config.promo_number ))==null?'':__t)+
'</div>\n  </div>\n\n  ';
 if (config.manageVirtualLines.displayCampaignSelector) { 
__p+='\n    <div class="sb-field-group" data-mount="advertiser_campaign_id">\n      <label class="sb-field-label">Invoca Campaign</label>\n      <div data-mount="advertiser-campaign-area"></div>\n      <span id="advertiser_campaign_fixed" style="'+
((__t=( config.displayIfExists(config.advertiser_campaign_name) ))==null?'':__t)+
'">'+
((__t=( config.advertiser_campaign_name ))==null?'':__t)+
'</span>\n      <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n    </div>\n    <div class="sb-field-group" data-affiliate-campaign-selector-row="true" style="'+
((__t=( config.displayIfExists(config.affiliate_campaign_name) ))==null?'':__t)+
'" data-mount="affiliate_campaign_id">\n      <label class="sb-field-label">'+
((__t=( affiliateNameFromNetwork ))==null?'':__t)+
' Campaign</label>\n      <div id="campaign-select" class="affiliate-campaign-area"></div>\n      <span id="affiliate_campaign_fixed" style="'+
((__t=( config.displayIfExists(config.affiliate_campaign_name) ))==null?'':__t)+
'">'+
((__t=( config.affiliate_campaign_name ))==null?'':__t)+
'</span>\n      <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n    </div>\n  ';
 } 
__p+='\n\n  ';
 if (config.displayPromoType) { 
__p+='\n    <div class="sb-field-group promo-type-controls" id="promo_type_controls" data-mount="promo_type">\n      <label class="sb-field-label">Number Type</label>\n      ';
 config.manageVirtualLines.numberTypes.forEach(function (numberType) { 
__p+='\n        <div class="custom-control custom-radio">\n          <input class="custom-control-input" type="radio" name="promo_type_switch" id="promo_type_switch_'+
((__t=( numberType.value ))==null?'':__t)+
'" value='+
((__t=( numberType.value ))==null?'':__t)+
' />\n          <label for="promo_type_switch_'+
((__t=( numberType.value ))==null?'':__t)+
'" class="custom-control-label">'+
((__t=( numberType.label ))==null?'':__t)+
'</label>\n        </div>\n      ';
 }) 
__p+='\n      <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n    </div>\n  ';
 } 
__p+='\n\n  ';
 if (config.manageVirtualLines.requireMediaType) { 
__p+='\n    <div class="sb-field-group" data-mount="media_type">\n      <label class="sb-field-label">Media Type</label>\n      <div data-mount="media_type-area"></div>\n      <span name="media_type-errors" class="color-error hidden">This field<span class="validation-text"></span>.</span>\n    </div>\n  ';
 } 
__p+='\n\n  <div data-group="adwords-account" class="sb-field-group ui-hidden" data-mount="adwords_account_id">\n    <label class="sb-field-label">Google Ads Account</label>\n    <div data-mount="adwords-account-area"></div>\n    <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n  </div>\n\n  <div class="sb-field-group" data-mount="description">\n    <label class="sb-field-label">Description</label>\n    <input type="text" placeholder="Optional description for reporting" data-description id="description" class="form-control" />\n    <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n  </div>\n\n  ';
 if (config.manageVirtualLines.numberSupport.lookup) { 
__p+='\n    <div class="ui-hidden" data-action="local-number-support">\n      <div data-mount="form-target-area-locator"/>\n    </div>\n  ';
 } else if (config.manageVirtualLines.numberSupport.lookLike) { 
__p+='\n    <div class="sb-field-group custom-typeahead ui-hidden" data-mount="promo_number_looks_like" data-action="local-number-support">\n      <label class="sb-field-label">Looks Like</label>\n      <i data-icon="help" class="icon--help js-popover" data-toggle="popover" data-trigger="hover" data-placement="right" data-original-title="Enter number to look like" data-content="Specify the first [3 to 5] digits you would like your new number to look like. We will try to find a match based on your entry."></i>\n\n      <div class="pr-medium w-75">\n        <input type="text" class="form-control" name="virtual_line[promo_number_looks_like]" placeholder="Optional, ie: 2031920193" />\n        <span data-mount="errors" class="sb-field-invalid-feedback"></span>\n      </div>\n    </div>\n  ';
 } 
__p+='\n</form>\n';
}
return __p;
};
